import { ProductType } from '@core/contracts/data-contracts';

export const getProductConfig = (activeProduct: ProductType) =>
  activeProduct === ProductType.Mobile
    ? {
      title: 'components.userProfile.letsGoMobile',
      headerIcon: 'mobile-internet',
      switchIcon: 'home-internet',
      switchText: 'components.userProfile.switchToHomeSubscription',
      switchProduct: ProductType.Internet,
    }
    : {
      title: 'components.userProfile.internet',
      headerIcon: 'home-internet',
      switchIcon: 'mobile-internet',
      switchText: 'components.userProfile.switchToMobileSubscription',
      switchProduct: ProductType.Mobile,
    };
